export const downloadFile = (fileUrl: string, fileName: any) => {
    // get file extension
    let fileExtension = fileUrl.split('.').pop()

    let xhr = new XMLHttpRequest()
    xhr.open('GET', fileUrl)
    xhr.responseType = 'blob'

    xhr.onload = () => {
        saveFile(xhr.response, fileExtension, fileName)
    }
    xhr.send()
}

const saveFile = (
    blob: Blob | MediaSource,
    fileExtension: string | undefined,
    fileName: any
) => {
    let anchor = document.createElement('a')
    document.body.appendChild(anchor)
    anchor.style.setProperty('display', 'none')

    let url = window.URL.createObjectURL(blob)
    anchor.href = url
    anchor.download = `${fileName}.${fileExtension}`
    anchor.click()
    window.URL.revokeObjectURL(url)
}

export const downloadFileFromResponse = (response: any, fileName: string) => {
  // Get content type from headers
  const contentType = response.headers['content-type'] || response.headers['Content-Type'] || 'application/pdf';
  
  // Determine file extension from content type
  let fileExtension: string;
  
  if (contentType.includes('application/pdf')) {
    fileExtension = 'pdf';
  } else if (contentType.includes('text/csv') || contentType.includes('application/csv')) {
    fileExtension = 'csv';
  } else if (contentType.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
    fileExtension = 'xlsx';
  } else if (contentType.includes('application/vnd.ms-excel')) {
    fileExtension = 'xls';
  } else {
    // Fallback to PDF
    fileExtension = 'pdf';
  }
  
  // response.data is already a blob when using responseType: 'blob'
  const blob = response.data;
  
  // Create temporary URL and download link
  const downloadUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');
  
  link.href = downloadUrl;
  link.download = `${fileName}.${fileExtension}`;
  link.style.display = 'none';
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  
  URL.revokeObjectURL(downloadUrl);
};